
<template>
    <div>
        <v-row justify="center">
            <v-card  style="[window.width <= 655 ? '{margin:3 !important;}' : 'margin:3 !important;'" flat >
                <div v-if="window.width <= 650" class="custom-card-content">
                    <div class="sections">
                        <div class="section-content-wrapper">
                            <div class="section-header-mobile">
                                <div><span>~</span></div>
                                <div><span>Setup Fees</span></div>
                                <div><span>Annual Fee</span></div>
                                <div><span>Total Fees</span></div>
                            </div>
                            <div class="section-data-row-mobile">
                                <div><span>Year 1</span></div>
                                <div><span>{{ total_setup_fees.total_setup_fee_year_one }}</span></div>
                                <div><span>{{ total_annual_fees.total_annual_fee_year_one }}</span></div>
                                <div><span>{{ total_fees.total_fee_year_one }}</span></div>
                            </div>
                            <div class="section-data-row-mobile">
                                <div><span>Year 2</span></div>
                                <div><span>{{ total_setup_fees.total_setup_fee_year_two }}</span></div>
                                <div><span>{{ total_annual_fees.total_annual_fee_year_two }}</span></div>
                                <div><span>{{ total_fees.total_fee_year_two }}</span></div>
                            </div>
                            <div class="section-data-row-mobile">
                                <div><span>Year 3</span></div>
                                <div><span>{{ total_setup_fees.total_setup_fee_year_three }}</span></div>
                                <div><span>{{ total_annual_fees.total_annual_fee_year_three }}</span></div>
                                <div><span>{{ total_fees.total_fee_year_three }}</span></div>
                            </div>
                            <div class="section-data-row-mobile" v-if="duration>=4">
                                <div><span>Year 4</span></div>
                                <div><span>{{ total_setup_fees.total_setup_fee_year_four }}</span></div>
                                <div><span>{{ total_annual_fees.total_annual_fee_year_four }}</span></div>
                                <div><span>{{ total_fees.total_fee_year_four }}</span></div>
                            </div>
                            <div class="section-data-row-mobile" v-if="duration>=5">
                                <div><span>Year 5</span></div>
                                <div><span>{{ total_setup_fees.total_setup_fee_year_five }}</span></div>
                                <div><span>{{ total_annual_fees.total_annual_fee_year_five }}</span></div>
                                <div><span>{{ total_fees.total_fee_year_five }}</span></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="window.width >= 651" class="custom-card-content">
                    <div class="sections">
                        <div class="section-header">
                            <div><span class="font-weight-regular text-h6">Year 0</span></div>
                            <div><span class="font-weight-regular text-h6">Year 1</span></div>
                            <div><span class="font-weight-regular text-h6">Year 2</span></div>
                            <div><span class="font-weight-regular text-h6">Year 3</span></div>
                            <div v-if="duration>=4"><span class="font-weight-regular text-h6">Year 4</span></div>
                            <div v-if="duration>=5"><span class="font-weight-regular text-h6">Year 5</span></div>
                        </div>
                        <div class="section-data-row">
                            <div><span class="font-weight-bold text-md-h6">Setup Fee</span></div>
                            <div><span class="font-weight-bold text-md-h6">{{ total_setup_fees.total_setup_fee_year_one }}</span></div>
                            <div><span class="font-weight-bold text-md-h6">{{ total_setup_fees.total_setup_fee_year_two }}</span></div>
                            <div><span class="font-weight-bold text-md-h6">{{ total_setup_fees.total_setup_fee_year_three }}</span></div>
                            <div v-if="duration>=4"><span class="font-weight-bold text-md-h6">{{ total_setup_fees.total_setup_fee_year_four }}</span></div>
                            <div v-if="duration>=5"><span class="font-weight-bold text-md-h6">{{ total_setup_fees.total_setup_fee_year_five }}</span></div>
                        </div>
                        <div class="section-data-row" v-if="pricingSection.pricing_assumptions.is_shown">
                            <div><span class="font-weight-regular text-md-h6">Plan Design Install Fee</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ pp_plan_design_installation_fee }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div v-if="duration>=4"><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div v-if="duration>=5"><span class="font-weight-regular text-md-h6">$0</span></div>
                        </div>
                        <div class="section-data-row" v-if="pricingSection.pricing_assumptions.is_shown">
                            <div><span class="font-weight-regular text-md-h6">Participant Install Fee</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ participant_install_fee }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div v-if="duration>=4"><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div v-if="duration>=5"><span class="font-weight-regular text-md-h6">$0</span></div>
                        </div>
                        <div class="section-data-row" v-if="pricingSection.pricing_assumptions.is_shown">
                            <div><span class="font-weight-regular text-md-h6">Plan Document Fee</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{pp_document_fee }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div v-if="duration>=4"><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div v-if="duration>=5"><span class="font-weight-regular text-md-h6">$0</span></div>
                        </div>
                        <div class="section-data-row" v-if="pricingSection.mep_pricing.is_shown">
                            <div><span class="font-weight-regular text-md-h6">Plan Sponsor - Plan Document</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ me_sponsor_document }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div v-if="duration>=4"><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div v-if="duration>=5"><span class="font-weight-regular text-md-h6">$0</span></div>
                        </div>
                        <div class="section-data-row" v-if="pricingSection.mep_pricing.is_shown">
                            <div><span class="font-weight-regular text-md-h6">Adopting Employer Agreement</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ me_adopting_employer }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div v-if="duration>=4"><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div v-if="duration>=5"><span class="font-weight-regular text-md-h6">$0</span></div>
                        </div>
                        <div class="section-data-row" v-if="pricingSection.three_sixteen.is_checked && !pricingSection.three_sixteen.use_basis_points.value">
                            <div><span class="font-weight-regular text-md-h6">3(16) Setup / Install</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ setup_install_fee_3_16 }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div v-if="duration>=4"><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div v-if="duration>=5"><span class="font-weight-regular text-md-h6">$0</span></div>
                        </div>
                        <div class="section-data-row" v-if="pricingSection.payroll_integration.is_checked">
                            <div><span class="font-weight-regular text-md-h6">Payroll Integration Base Fee</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ dollar(pricingSection.payroll_integration.pi_base_fee.value) }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div v-if="duration>=4"><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div v-if="duration>=5"><span class="font-weight-regular text-md-h6">$0</span></div>
                        </div>
                        <div class="section-data-row" v-if="pricingSection.custom_additions.is_checked">
                            <div><span class="font-weight-regular text-md-h6">Custom Additions</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ dollar(pricingSection.custom_additions.total) }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div v-if="duration>=4"><span class="font-weight-regular text-md-h6">$0</span></div>
                            <div v-if="duration>=5"><span class="font-weight-regular text-md-h6">$0</span></div>
                        </div>
                        <v-divider></v-divider>
                        <div class="section-data-row">
                            <div><span class="font-weight-bold text-md-h6">Annual Fee</span></div>
                            <div><span class="font-weight-bold text-md-h6">{{ total_annual_fees.total_annual_fee_year_one }}</span></div>
                            <div><span class="font-weight-bold text-md-h6">{{ total_annual_fees.total_annual_fee_year_two }}</span></div>
                            <div><span class="font-weight-bold text-md-h6">{{ total_annual_fees.total_annual_fee_year_three }}</span></div>
                            <div v-if="duration>=4"><span class="font-weight-bold text-md-h6">{{ total_annual_fees.total_annual_fee_year_four }}</span></div>
                            <div v-if="duration>=5"><span class="font-weight-bold text-md-h6">{{ total_annual_fees.total_annual_fee_year_five }}</span></div>
                        </div>
                        <div class="section-data-row" v-if="pricingSection.pricing_assumptions.is_shown">
                            <div><span class="font-weight-regular text-md-h6">Base Annual Admin Fee</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ pp_annual_admin_fee }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ pp_annual_admin_fee }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ pp_annual_admin_fee }}</span></div>
                            <div v-if="duration>=4"><span class="font-weight-regular text-md-h6">{{ pp_annual_admin_fee }}</span></div>
                            <div v-if="duration>=5"><span class="font-weight-regular text-md-h6">{{ pp_annual_admin_fee }}</span></div>
                        </div>
                        <div class="section-data-row" v-if="pricingSection.pricing_assumptions.is_shown">
                            <div><span class="font-weight-regular text-md-h6">Annual Fees for Participants</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ annual_participant_fee }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ annual_participant_fee }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ annual_participant_fee }}</span></div>
                            <div v-if="duration>=4"><span class="font-weight-regular text-md-h6">{{ annual_participant_fee }}</span></div>
                            <div v-if="duration>=5"><span class="font-weight-regular text-md-h6">{{ annual_participant_fee }}</span></div>
                        </div>
                        <div class="section-data-row" v-if="pricingSection.mep_pricing.is_shown">
                            <div><span class="font-weight-regular text-md-h6">MEP Tier Pricing</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ me_total }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ me_total }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ me_total }}</span></div>
                            <div v-if="duration>=4"><span class="font-weight-regular text-md-h6">{{ me_total }}</span></div>
                            <div v-if="duration>=5"><span class="font-weight-regular text-md-h6">{{ me_total }}</span></div>
                        </div>
                        <div class="section-data-row" v-if="pricingSection.plan_doc_maint.is_checked">
                            <div><span class="font-weight-regular text-md-h6">Plan Document Maintenance Fee</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ pp_document_maintenance_fee }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ pp_document_maintenance_fee }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ pp_document_maintenance_fee }}</span></div>
                            <div v-if="duration>=4"><span class="font-weight-regular text-md-h6">{{ pp_document_maintenance_fee }}</span></div>
                            <div v-if="duration>=5"><span class="font-weight-regular text-md-h6">{{ pp_document_maintenance_fee }}</span></div>
                        </div>
                        <div class="section-data-row" v-if="pricingSection.audit_fee.is_checked">
                            <div><span class="font-weight-regular text-md-h6">Audit Fee</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ pp_audit_fee }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ pp_audit_fee }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ pp_audit_fee }}</span></div>
                            <div v-if="duration>=4"><span class="font-weight-regular text-md-h6">{{ pp_audit_fee }}</span></div>
                            <div v-if="duration>=5"><span class="font-weight-regular text-md-h6">{{ pp_audit_fee }}</span></div>
                        </div>
                        <div class="section-data-row" v-if="pricingSection.three_sixteen.is_checked && !pricingSection.three_sixteen.use_basis_points.value">
                            <div><span class="font-weight-regular text-md-h6">3(16) Base Annual Admin Fee</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ annual_admin_fee_3_16 }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ annual_admin_fee_3_16 }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ annual_admin_fee_3_16 }}</span></div>
                            <div v-if="duration>=4"><span class="font-weight-regular text-md-h6">{{ annual_admin_fee_3_16 }}</span></div>
                            <div v-if="duration>=5"><span class="font-weight-regular text-md-h6">{{ annual_admin_fee_3_16 }}</span></div>
                        </div>
                        <div class="section-data-row" v-if="pricingSection.three_sixteen.is_checked && !pricingSection.three_sixteen.use_basis_points.value">
                            <div><span class="font-weight-regular text-md-h6">3(16) Annual Fees for Participant</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ annual_fees_3_16 }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ annual_fees_3_16 }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ annual_fees_3_16 }}</span></div>
                            <div  v-if="duration>=4"><span class="font-weight-regular text-md-h6">{{ annual_fees_3_16 }}</span></div>
                            <div  v-if="duration>=5"><span class="font-weight-regular text-md-h6">{{ annual_fees_3_16 }}</span></div>
                        </div>
                        <div class="section-data-row" v-if="pricingSection.three_sixteen.is_checked && pricingSection.three_sixteen.use_basis_points.value">
                            <div><span class="font-weight-regular text-md-h6">3(16) Basis Points Fees</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ basis_points_fees_3_16 }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ basis_points_fees_3_16 }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ basis_points_fees_3_16 }}</span></div>
                            <div  v-if="duration>=4"><span class="font-weight-regular text-md-h6">{{ basis_points_fees_3_16 }}</span></div>
                            <div  v-if="duration>=5"><span class="font-weight-regular text-md-h6">{{ basis_points_fees_3_16 }}</span></div>
                        </div>
                        <div class="section-data-row" v-if="pricingSection.payroll_integration.is_checked">
                            <div><span class="font-weight-regular text-md-h6">Payroll Integration</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ dollar(pricingSection.payroll_integration.total) }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ dollar(pricingSection.payroll_integration.total) }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ dollar(pricingSection.payroll_integration.total) }}</span></div>
                            <div  v-if="duration>=4"><span class="font-weight-regular text-md-h6">{{ dollar(pricingSection.payroll_integration.total) }}</span></div>
                            <div  v-if="duration>=5"><span class="font-weight-regular text-md-h6">{{ dollar(pricingSection.payroll_integration.total) }}</span></div>
                        </div>
                        <div class="section-data-row" v-if="pricingSection.payroll_processing.is_checked">
                            <div><span class="font-weight-regular text-md-h6">Payroll Processing</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ dollar(pricingSection.payroll_processing.total) }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ dollar(pricingSection.payroll_processing.total) }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ dollar(pricingSection.payroll_processing.total) }}</span></div>
                            <div  v-if="duration>=4"><span class="font-weight-regular text-md-h6">{{ dollar(pricingSection.payroll_processing.total) }}</span></div>
                            <div  v-if="duration>=5"><span class="font-weight-regular text-md-h6">{{ dollar(pricingSection.payroll_processing.total) }}</span></div>
                        </div>
                        <div class="section-data-row" v-if="pricingSection.pbgc.is_checked">
                            <div><span class="font-weight-regular text-md-h6">PBGC</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ pbgc_total }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ pbgc_total }}</span></div>
                            <div><span class="font-weight-regular text-md-h6">{{ pbgc_total }}</span></div>
                            <div  v-if="duration>=4"><span class="font-weight-regular text-md-h6">{{ pbgc_total }}</span></div>
                            <div  v-if="duration>=5"><span class="font-weight-regular text-md-h6">{{ pbgc_total }}</span></div>
                        </div>
                        <v-divider></v-divider>
                        <div class="section-data-row">
                            <div class="font-weight-bold text-md-h6"><span>Total Fees</span></div>
                            <div class="font-weight-bold text-md-h6"><span>{{ total_fees.total_fee_year_one }}</span></div>
                            <div class="font-weight-bold text-md-h6"><span>{{ total_fees.total_fee_year_two }}</span></div>
                            <div class="font-weight-bold text-md-h6"><span>{{ total_fees.total_fee_year_three }}</span></div>
                            <div class="font-weight-bold text-md-h6" v-if="duration>=4"><span>{{ total_fees.total_fee_year_four }}</span></div>
                            <div class="font-weight-bold text-md-h6" v-if="duration>=5"><span>{{ total_fees.total_fee_year_five }}</span></div>
                        </div>
                    </div>
                </div>
            </v-card>
        </v-row>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import {safeInt} from '@/store/global_helpers/utility.js';
    // import {mapActions, mapGetters} from 'vuex';
    export default {
         props: {
            // duration: [Number],
        },
        name: 'gross_estimates',
        data: function() {
            return {
                styleElement: null,
                window: {
                    width: 0,
                    height: 0
                },
                duration: 5,
                json: false,
            }
            
        },
        
        mounted(){
            this.duration = this.planOpportunityViewmodel.plan_opportunity.duration
        },

        created() {
            window.addEventListener('resize', this.handleResize);
            this.handleResize();
        },

        computed: {
            ...mapGetters({
                proposalViewModels: 'getProposalViewModels',
                planOpportunityViewmodel: 'getplanOpportunityViewmodel',
                pricingSection: 'getPricingSection',
            }),
            
            participant_install_fee() {
                let x = parseInt(this.json.pp_install_participant_fee) * parseInt(this.json.pa_participants_balance);
                return this.dollar(x);
            },
            
            pp_plan_design_installation_fee(){
                return this.dollar(this.json.pp_plan_design_installation_fee);
            },
            
            total_annual_fees(){
                return {
                   total_annual_fee_year_one:   this.dollar(this.json.total_annual_fee_year_one),
                   total_annual_fee_year_two:   this.dollar(this.json.total_annual_fee_year_two),
                   total_annual_fee_year_three: this.dollar(this.json.total_annual_fee_year_three),
                   total_annual_fee_year_four:  this.dollar(this.json.total_annual_fee_year_four),
                   total_annual_fee_year_five:  this.dollar(this.json.total_annual_fee_year_five),
                }
            },
            
            total_fees() {
                return {
                   total_fee_year_one:   this.dollar(this.json.total_fee_year_one),
                   total_fee_year_two:   this.dollar(this.json.total_fee_year_two),
                   total_fee_year_three: this.dollar(this.json.total_fee_year_three),
                   total_fee_year_four:  this.dollar(this.json.total_fee_year_four),
                   total_fee_year_five:  this.dollar(this.json.total_fee_year_five),
                }
            },
            
            annual_participant_fee(){
                let x = parseInt(this.json.pp_annual_participant_fee) * parseInt(this.json.pa_participants_balance)
                return this.dollar(x)
            },
            
            annual_fees_3_16(){
                return this.dollar(this.json.participant_annual_charges_3_16)
            },

            basis_points_fees_3_16(){
                let points = 0 
                if (this.pricingSection.three_sixteen.basis_points.value) {
                    points = safeInt(this.pricingSection.three_sixteen.basis_points.value);
                }
                let assets = 0
                if (this.pricingSection.mep_pricing.is_shown){
                    assets = safeInt(this.pricingSection.mep_pricing.plan_assets.value);
                } else {
                    assets = safeInt(this.pricingSection.pricing_assumptions.plan_assets.value);
                }
                let x = assets * (points * .0001)
                return this.dollar(x)
            },
            
            annual_admin_fee_3_16(){
                return this.dollar(this.json.annual_admin_fee_3_16)
            },

            pa_participants_balance(){
                return this.dollar(this.json.pa_participants_balance)
            },

            pp_annual_admin_fee(){
                return this.dollar(this.json.pp_annual_admin_fee)
            },
                        
            pp_audit_fee(){
                return this.dollar(this.json.pp_annual_audit_fee)
            },

            pp_annual_participant_fee(){
                return this.dollar(this.json.pp_annual_participant_fee)
            },

            pp_document_fee(){
                return this.dollar(this.json.pp_document_fee)
            },

            me_total(){
                return this.dollar(this.json.me_total)
            },

            me_sponsor_document(){
                return this.dollar(this.json.me_sponsor_document)
            },

            me_adopting_employer(){
                return this.dollar(this.json.me_adopting_employer)
            },

            pp_document_maintenance_fee(){
                return this.dollar(this.json.pp_document_maintenance_fee)
            },

            pp_install_participant_fee(){
                return this.dollar(this.json.pp_install_participant_fee)
            },

            setup_install_fee_3_16(){
                return this.dollar(this.json.setup_install_fee_3_16)
            },
            
            total_setup_fees(){
                return{
                    total_setup_fee_year_one:   this.dollar(this.json.total_setup_fee_year_one),
                    total_setup_fee_year_two:   this.dollar(this.json.total_setup_fee_year_two),
                    total_setup_fee_year_three: this.dollar(this.json.total_setup_fee_year_three),
                    total_setup_fee_year_four:  this.dollar(this.json.total_setup_fee_year_four),
                    total_setup_fee_year_five:  this.dollar(this.json.total_setup_fee_year_five)
                }
            },

            pbgc_total(){
                let per = safeInt(this.pricingSection.pbgc.per_participant.value);
                let par = 0;
                if (this.pricingSection.pricing_assumptions.is_shown){
                    par = safeInt(this.pricingSection.pricing_assumptions.participants_with_balance.value);
                } else {
                    par = this.pricingSection.mep_pricing.participant_count;
                }
                let x = (per*par)+ safeInt(this.pricingSection.pbgc.premium_filing.value);
                return this.dollar(x)
            }
        },

        destroyed() {
            window.removeEventListener('resize', this.handleResize);
        },

        methods: {
            safeInt(val){
                val = val ? val : 0;
                let x = String(val).replaceAll('$','').replaceAll(',','');
                return parseInt(x);
            },

            safeComma(val){
                let x = this.safeInt(val)
                return Number(x).toLocaleString("US", {currency: "USD"})
            },

            dollar(val){
                let x = this.safeComma(val)
                return `$${x}`;
            },

            handleResize() {
                this.window.width = window.innerWidth;
                this.window.height = window.innerHeight;
            },
            
            applyStyle(styleDef) {
                let styleElement = document.createElement('style')
                styleElement.type = 'text/css'
                document.head.appendChild(styleElement)
                styleElement.innerHTML = styleDef
                return styleElement
            },
        },

        watch: {
            "proposalViewModels"(){
                console.log('proposalViewModels watcher');
                if (!this.json) {
                    this.json = this.proposalViewModels[0].pricing;
                    console.log(this.proposalViewModels[0]);
                    console.log(JSON.stringify(this.proposalViewModels[0].tokens));
                }
                console.log(this.proposalViewModels.length);
            },

            style: function(style) {
                if (this.styleElement) {
                    this.styleElement.parentNode.removeChild(this.styleElement)
                }
                this.styleElement = this.applyStyle(style)
            },
        }
    }

</script>

<style scoped>

    .custom-toolbar,
    .custom-toolbar >>> .v-toolbar__content {
        height: 50px !important;
    }

    .custom-toolbar span {
        flex-grow: 1;
    }

    .custom-toolbar.content-title, 
    .custom-toolbar.content-title >>> .v-toolbar__content {
        height: 35px !important;
        line-height: 27px;
        display: block;
        text-align: center;
        margin-bottom: 15px;
    }

    .sections {
        margin-top: 15px;
    }

    .data-row-label {
        min-width: 200px;
    }

    .data-row-amount {
        min-height: 30px;
        text-align: left;
        overflow-x: scroll;
        overflow-y: hidden;
    }

    .data-row-amount-header,
    .section-header,
    .section-header-mobile,
    .section-data-row,
    .section-data-row-mobile,
    .data-row-amount-one,
    .data-row-amount-two,
    .data-row-amount-total,
    .data-row-amount-carryover {
        display: flex;
        width: 100%;
    }

    .sections:nth-of-type(2) .section-content-wrapper {
        margin-top: 50px;
    }

    .sections .section-header-mobile > div,
    .sections .section-data-row-mobile > div {
        padding: 10px;
        margin-left: 5px;
        margin-right: 5px;
        text-align: center;
        line-height: 1;
    }

    .sections:nth-of-type(1) .section-header-mobile > div,
    .sections:nth-of-type(1) .section-data-row-mobile > div {
        width: calc(25% - 5px);
    }

    .sections:nth-of-type(2) .section-header-mobile > div,
    .sections:nth-of-type(2) .section-data-row-mobile > div {
        width: calc(20% - 5px);
        position: relative;
        text-align: initial;
    }

    .sections:nth-of-type(2) .section-header-mobile > div span {
        position: absolute;
        bottom: 0;
        text-align: center;
    }

    .sections:nth-of-type(2) .section-data-row-mobile > div:nth-of-type(n+2):not(:nth-of-type(n+4)) {
        word-wrap: break-word;
        word-break: break-all;
        background-color: lightblue;
    }
    
    .sections:nth-of-type(2) .section-data-row-mobile > div:nth-of-type(4) input {
        font-weight: 600;
        color: #13cc44;
        text-align: center;
        background-color: transparent;
        pointer-events: none;
    }

    .sections:nth-of-type(2) .section-data-row-mobile > div:nth-of-type(5) input {
        text-align: center;
        pointer-events: none;
    }

    @media only screen and (min-width: 397px) {

        .sections:nth-of-type(2) .section-data-row-mobile > div:nth-of-type(n+2) {
            max-height: 36px;
        }
    }

    .sections:nth-of-type(2) .section-data-row-mobile > div input,
    .sections:nth-of-type(2) .section-data-row-mobile > div input {
        width: 100%;
        resize: none;
        outline: none;
        overflow: hidden;
    }
    
    .section-header-mobile > div {
        padding-bottom: 2px !important;
    }

    .sections:nth-of-type(2) .section-data-row-mobile {
        padding-top: 20px;
    }

    .section-header-mobile > div:nth-of-type(n+2) {
        border-bottom: 1px solid grey;
    }

    .sections:nth-of-type(1) .section-data-row-mobile > div:nth-of-type(4) {
        font-weight: 600;
    }



    /* NON MOBILE CSS */

    .sections .section-header > div:nth-of-type(1),
    .sections .section-data-row > div:nth-of-type(1) {
        width: 900px;
        font-weight: 600;
        margin: 10px 10px 10px 10px;
        padding: 5px;
        max-height: 30px;
    }

    .sections .section-header > div:nth-of-type(1) {
        color: transparent;
    }

    .sections .section-header > div:nth-of-type(n+2),
    .sections .section-data-row > div:nth-of-type(n+2) {
        width: calc(30% - 5px);
        text-align: right;
        margin: 10px 10px 10px 10px;
        padding: 5px;
        background-color: lightblue;
    }

    .sections .section-header > div,
    .sections:nth-of-type(1) .section-data-row > div:nth-of-type(n+2),
    .sections .section-data-row:nth-of-type(n+4) > div {
        background-color: transparent !important;
    }

    .sections:nth-of-type(2) .section-data-row:nth-of-type(4) > div:nth-of-type(n+2) {
        font-weight: 600;
        color: #13cc44;
    }

    .sections .section-header > div:nth-of-type(n+2) {
        border-bottom: 1px solid grey;
    }

    .sections .section-data-row > div input {
        width: 100%;
        outline: none;
    }

    .sections:nth-of-type(1) .section-data-row:nth-of-type(3) > div input {
        width: 100%;
        outline: none;
    }
    
    .update-credit-btn >>> .v-btn__content {
        text-transform: capitalize;
    }


    /**************** MEDIA QUERY ***************/

    @media only screen and (min-width: 100%) {
        .sections .section-header > div:nth-of-type(1),
        .sections .section-data-row > div:nth-of-type(1) {
            /*width: 350px;*/
        }
    }


</style>